import "./Speaking.module.css";
import Header from "@/reusable_sections/Header";
import BespokePeptideSynthesis from "./sections/BespokePeptideSynthesis";
import RideCategories from "./sections/RideCategories";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function SpeakingPage() {
  return <div>
      <Header />
      <BespokePeptideSynthesis />
      <RideCategories />
      <ContactUs />
      <Footer />
    </div>;
}